/* eslint-disable prettier/prettier */
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SuperAdminDashboard } from '../pages/dashboards/SuperAdminDashboard';
import { CompanyAdminDashboard } from '../pages/dashboards/CompanyAdminDashboard';
import { UserDashboard } from '../pages/dashboards/UserDashboard';

export const RoleRedirect = () => {
  const { user } = useAuth();
  const role = user?.role?.name;

  if (role === 'SUPER_ADMIN') return <SuperAdminDashboard />;
  if (role === 'COMPANY_ADMIN') return <CompanyAdminDashboard/>;
  if (role === 'USER') return <UserDashboard />;

  return <Navigate to="/login" />;
};
